import './place-bet-xd.scss';
import { useEffect, useRef, useState } from 'react';
import { ConfirmMoneyMiniXD, CountMoneyMiniXD, CountUserBetXD, TypePlaceMiniXD } from 'models/mini-xd-model';
import { animateValue } from 'utils/function';
interface Props {
    moneyCount: CountMoneyMiniXD;
    countUser: CountUserBetXD;
    moneyConfirm: ConfirmMoneyMiniXD;
    issue: number;
    result: string[] | null;
    onSelectBet: (placeEl: HTMLButtonElement, place: TypePlaceMiniXD) => void;
}
export default function PlaceBetXd(props: Props) {
    const { moneyCount, countUser, moneyConfirm, issue, result, onSelectBet } = props;

    // place animation chẵn
    const moneyCountEvenRef = useRef<HTMLParagraphElement>(null);
    const currentCountEven = useRef(0);
    // place animation lẻ
    const moneyCountOddRef = useRef<HTMLParagraphElement>(null);
    const currentCountOdd = useRef(0);

    // place animation 3 do 1 trang
    const moneyCount3RedRef = useRef<HTMLParagraphElement>(null);
    const currentCount3Red = useRef(0);

    // place animation 3 trang 1 do
    const moneyCount3WhiteRef = useRef<HTMLParagraphElement>(null);
    const currentCount3White = useRef(0);
    // place animation 4 do
    const moneyCountRedRef = useRef<HTMLParagraphElement>(null);
    const currentCountRed = useRef(0);
    // place animation 4 trang
    const moneyCountWhiteRef = useRef<HTMLParagraphElement>(null);
    const currentCountWhite = useRef(0);

    const [totalResult, setTotalResult] = useState<number | null>(null);
    const [totalBet, setTotalBet] = useState(0);

    useEffect(() => {
        if (result) {
            setTimeout(() => {
                const total = result.reduce((a, b) => Number(a) + Number(b), 0);
                setTotalResult(total);
            }, 3000);
        } else {
            setTotalResult(null);
        }
    }, [result]);

    useEffect(() => {
        currentCountEven.current = 0;
        currentCountOdd.current = 0;
        currentCount3Red.current = 0;
        currentCount3White.current = 0;
        currentCountRed.current = 0;
        currentCountWhite.current = 0;
    }, [issue]);

    useEffect(() => {
        const total =
            moneyConfirm.moneyConfirmEven +
            moneyConfirm.moneyConfirmOdd +
            moneyConfirm.moneyConfirmRed +
            moneyConfirm.moneyConfirmWhite +
            moneyConfirm.moneyConfirm3White +
            moneyConfirm.moneyConfirm3Red;
        setTotalBet(total);
    }, [moneyConfirm]);

    useEffect(() => {
        //chẵn
        if (moneyCount.moneyCountEven > currentCountEven.current && moneyCountEvenRef.current) {
            animateValue(moneyCountEvenRef.current, currentCountEven.current, moneyCount.moneyCountEven, 200, () => {
                currentCountEven.current = moneyCount.moneyCountEven;
            });
        }
        //lẻ
        if (moneyCount.moneyCountOdd > currentCountOdd.current && moneyCountOddRef.current) {
            animateValue(moneyCountOddRef.current, currentCountOdd.current, moneyCount.moneyCountOdd, 200, () => {
                currentCountOdd.current = moneyCount.moneyCountOdd;
            });
        }

        //3 do 1 trang
        if (moneyCount.moneyCount3Red > currentCount3Red.current && moneyCount3RedRef.current) {
            animateValue(moneyCount3RedRef.current, currentCount3Red.current, moneyCount.moneyCount3Red, 200, () => {
                currentCount3Red.current = moneyCount.moneyCount3Red;
            });
        }

        //3 trang 1 do
        if (moneyCount.moneyCount3White > currentCount3White.current && moneyCount3WhiteRef.current) {
            animateValue(moneyCount3WhiteRef.current, currentCount3White.current, moneyCount.moneyCount3White, 200, () => {
                currentCount3White.current = moneyCount.moneyCount3White;
            });
        }

        //4 do
        if (moneyCount.moneyCountRed > currentCountRed.current && moneyCountRedRef.current) {
            animateValue(moneyCountRedRef.current, currentCountRed.current, moneyCount.moneyCountRed, 200, () => {
                currentCountRed.current = moneyCount.moneyCountRed;
            });
        }

        //4 trang
        if (moneyCount.moneyCountWhite > currentCountWhite.current && moneyCountWhiteRef.current) {
            animateValue(moneyCountWhiteRef.current, currentCountWhite.current, moneyCount.moneyCountWhite, 200, () => {
                currentCountWhite.current = moneyCount.moneyCountWhite;
            });
        }
    }, [moneyCount]);

    const selectPlace = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, place: TypePlaceMiniXD) => {
        const targetEl = event.target as HTMLElement;
        const btnEl = targetEl.closest('button');
        if (btnEl) {
            onSelectBet(btnEl, place);
        }
    };

    return (
        <div className="place-bet-xd">
            <div className="ion-row">
                <div className="ion-col ion-col-chan">
                    <button className="bet-chan place-item" data-infinity="even" onClick={(e) => selectPlace(e, 'even')}>
                        <div className="place-info">
                            <img className="text-place" src={require(`assets/images/mini-xd/text-even.png`)} alt="" />
                            <span className="text-white-gradient">1:0.96</span>
                        </div>
                        <div className="countMoney">
                            <p className="text-gradient" ref={moneyCountEvenRef}>
                                {new Intl.NumberFormat().format(moneyCount.moneyCountEven || 0)}
                            </p>
                            <div className="user-bet">
                                <img src={require(`assets/images/mini-xd/team.png`)} alt="" />
                                {countUser.userEven}
                            </div>
                        </div>
                        <span className={`win-effect ${totalResult && totalResult % 2 === 0 ? 'show' : ''}`}></span>
                        <p className="total-money-typebet">
                            <span></span>
                        </p>
                        {moneyConfirm.moneyConfirmEven > 0 && (
                            <p className="total-money">
                                <span>{new Intl.NumberFormat().format(moneyConfirm.moneyConfirmEven)}</span>
                            </p>
                        )}
                    </button>
                </div>
                <div className="ion-col ion-col-count">
                    <div className="timerCount">
                        <div className="total-bet">
                            <span>$</span>
                            <p>{new Intl.NumberFormat().format(totalBet || 0)}</p>
                        </div>
                    </div>
                </div>
                <div className="ion-col ion-col-chan">
                    <button className="bet-le place-item" data-infinity="odd" onClick={(e) => selectPlace(e, 'odd')}>
                        <div className="place-info">
                            <img className="text-place" src={require(`assets/images/mini-xd/text-odd.png`)} alt="" />
                            <span className="text-white-gradient">1:0.96</span>
                        </div>
                        <div className="countMoney">
                            <p className="text-gradient" ref={moneyCountOddRef}>
                                {new Intl.NumberFormat().format(moneyCount.moneyCountOdd || 0)}
                            </p>
                            <div className="user-bet">
                                {countUser.userOdd}
                                <img src={require(`assets/images/mini-xd/team.png`)} alt="" />
                            </div>
                        </div>
                        <span className={`win-effect ${totalResult && totalResult % 2 !== 0 ? 'show' : ''}`}></span>
                        <p className="total-money-typebet">
                            <span></span>
                        </p>
                        {moneyConfirm.moneyConfirmOdd > 0 && (
                            <p className="total-money">
                                <span>{new Intl.NumberFormat().format(moneyConfirm.moneyConfirmOdd)}</span>
                            </p>
                        )}
                    </button>
                </div>
            </div>
            <div className="ion-row">
                <div className="ion-col">
                    <button
                        className="bet-ratio red3-1white place-item"
                        data-infinity="1white3red"
                        onClick={(e) => selectPlace(e, '1white3red')}
                    >
                        <div className="place-info">
                            <div className="dot-list">
                                <img src={require(`assets/images/mini-xd/red.png`)} alt="" />
                                <img src={require(`assets/images/mini-xd/red.png`)} alt="" />
                                <img src={require(`assets/images/mini-xd/red.png`)} alt="" />
                                <img src={require(`assets/images/mini-xd/white.png`)} alt="" />
                            </div>
                            <span className="text-white-gradient">1:2.9</span>
                        </div>
                        <div className="countMoney">
                            <p className="text-gradient" ref={moneyCount3RedRef}>
                                {new Intl.NumberFormat().format(moneyCount.moneyCount3Red || 0)}
                            </p>
                            <div className="user-bet">
                                <img src={require(`assets/images/mini-xd/team.png`)} alt="" />
                                {countUser.user3Red}
                            </div>
                        </div>
                        <span className={`win-effect ${totalResult === 3 ? 'show' : ''}`}></span>
                        <div className="inner-btn">
                            {moneyConfirm.moneyConfirm3Red > 0 && (
                                <p className="total-money">
                                    <span>{new Intl.NumberFormat().format(moneyConfirm.moneyConfirm3Red)}</span>
                                </p>
                            )}
                        </div>
                    </button>
                </div>
                <div className="ion-col">
                    <button
                        className="bet-ratio white3-1red place-item"
                        data-infinity="3white1red"
                        onClick={(e) => selectPlace(e, '3white1red')}
                    >
                        <div className="place-info">
                            <div className="dot-list">
                                <img src={require(`assets/images/mini-xd/white.png`)} alt="" />
                                <img src={require(`assets/images/mini-xd/white.png`)} alt="" />
                                <img src={require(`assets/images/mini-xd/white.png`)} alt="" />
                                <img src={require(`assets/images/mini-xd/red.png`)} alt="" />
                            </div>
                            <span className="text-white-gradient">1:2.9</span>
                        </div>
                        <div className="countMoney">
                            <p className="text-gradient" ref={moneyCount3WhiteRef}>
                                {new Intl.NumberFormat().format(moneyCount.moneyCount3White || 0)}
                            </p>
                            <div className="user-bet">
                                {countUser.user3White}
                                <img src={require(`assets/images/mini-xd/team.png`)} alt="" />
                            </div>
                        </div>
                        <span className={`win-effect ${totalResult === 1 ? 'show' : ''}`}></span>
                        <div className="inner-btn">
                            {moneyConfirm.moneyConfirm3White > 0 && (
                                <p className="total-money">
                                    <span>{new Intl.NumberFormat().format(moneyConfirm.moneyConfirm3White || 0)}</span>
                                </p>
                            )}
                        </div>
                    </button>
                </div>
            </div>

            <div className="ion-row">
                <div className="ion-col">
                    <button className="bet-ratio red4 place-item" data-infinity="red" onClick={(e) => selectPlace(e, 'red')}>
                        <div className="place-info">
                            <div className="dot-list">
                                <img src={require(`assets/images/mini-xd/red.png`)} alt="" />
                                <img src={require(`assets/images/mini-xd/red.png`)} alt="" />
                                <img src={require(`assets/images/mini-xd/red.png`)} alt="" />
                                <img src={require(`assets/images/mini-xd/red.png`)} alt="" />
                            </div>
                            <span className="text-white-gradient">1:14</span>
                        </div>
                        <div className="countMoney">
                            <p className="text-gradient" ref={moneyCountRedRef}>
                                {new Intl.NumberFormat().format(moneyCount.moneyCountRed || 0)}
                            </p>
                            <div className="user-bet">
                                <img src={require(`assets/images/mini-xd/team.png`)} alt="" />
                                {countUser.userRed}
                            </div>
                        </div>
                        <span className={`win-effect ${totalResult === 4 ? 'show' : ''}`}></span>
                        <div className="inner-btn">
                            {moneyConfirm.moneyConfirmRed > 0 && (
                                <p className="total-money">
                                    <span>{new Intl.NumberFormat().format(moneyConfirm.moneyConfirmRed)}</span>
                                </p>
                            )}
                        </div>
                    </button>
                </div>
                <div className="ion-col">
                    <button className="bet-ratio white4 place-item" data-infinity="white" onClick={(e) => selectPlace(e, 'white')}>
                        <div className="place-info">
                            <div className="dot-list">
                                <img src={require(`assets/images/mini-xd/white.png`)} alt="" />
                                <img src={require(`assets/images/mini-xd/white.png`)} alt="" />
                                <img src={require(`assets/images/mini-xd/white.png`)} alt="" />
                                <img src={require(`assets/images/mini-xd/white.png`)} alt="" />
                            </div>
                            <span className="text-white-gradient">1:14</span>
                        </div>
                        <div className="countMoney">
                            <p className="text-gradient" ref={moneyCountWhiteRef}>
                                {new Intl.NumberFormat().format(moneyCount.moneyCountWhite || 0)}
                            </p>
                            <div className="user-bet">
                                {countUser.userWhite}
                                <img src={require(`assets/images/mini-xd/team.png`)} alt="" />
                            </div>
                        </div>
                        <span className={`win-effect ${totalResult === 0 ? 'show' : ''}`}></span>
                        <div className="inner-btn">
                            {moneyConfirm.moneyConfirmWhite > 0 && (
                                <p className="total-money">
                                    <span>{new Intl.NumberFormat().format(moneyConfirm.moneyConfirmWhite)}</span>
                                </p>
                            )}
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
}
